import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { IllustrativeBadge } from "@/components/IllustrativeBadge";
import { ArrowLeft, Clock, MapPin, ArrowRight } from "lucide-react";

const ACTIVITIES = [
  { name: "Community Café", when: "Mon–Fri · 9:00–14:00", where: "The Long Room", tag: "Drop-in", desc: "Affordable food, warm space and friendly faces. Everyone welcome." },
  { name: "Pottery Studio", when: "Tuesdays · 18:00–20:00", where: "The Workshop", tag: "Class", desc: "Hand-building and wheel throwing for all levels. Materials included." },
  { name: "Youth Club", when: "Wednesdays · 16:00–18:30", where: "Studio 2", tag: "Young people", desc: "Games, music and creative projects for ages 11–16." },
  { name: "Job & Skills Club", when: "Thursdays · 10:00–12:00", where: "Meeting Room A", tag: "Support", desc: "CV help, applications and confidence-building with volunteer mentors." },
  { name: "Growing Together", when: "Saturdays · 10:00–12:00", where: "The Garden Room", tag: "Group", desc: "Community gardening, seasonal planting and shared harvests." },
  { name: "Parent & Toddler", when: "Fridays · 9:30–11:00", where: "The Long Room", tag: "Family", desc: "Play, songs and a chance for parents and carers to connect." },
];

export default function Explore() {
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-6xl px-5 py-10 sm:px-8" data-testid="explore-page">
      <button onClick={() => nav("/")} className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-mill-muted hover:text-mill-ink" data-testid="explore-back">
        <ArrowLeft className="h-4 w-4" /> The Mill home
      </button>
      <h1 className="font-display text-3xl font-bold text-mill-ink sm:text-4xl">What's on at The Mill</h1>
      <p className="mt-2 max-w-2xl text-mill-muted">Browse our regular activities, groups and spaces. No sign-in needed — just come along, or start a journey when you're ready.</p>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ACTIVITIES.map((a) => (
          <div key={a.name} className="rounded-2xl border border-stone-200 bg-white p-5" data-testid={`activity-${a.name.toLowerCase().replace(/\W+/g, "-")}`}>
            <div className="flex items-center justify-between">
              <span className="rounded-full bg-mill-alt px-2.5 py-1 text-[11px] font-semibold text-mill-moss">{a.tag}</span>
            </div>
            <h3 className="mt-3 font-display text-lg font-semibold text-mill-ink">{a.name}</h3>
            <p className="mt-1 text-sm text-mill-muted">{a.desc}</p>
            <div className="mt-3 space-y-1 text-xs text-mill-muted">
              <p className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {a.when}</p>
              <p className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {a.where}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 flex flex-col items-start gap-4 rounded-3xl border border-stone-200 bg-mill-alt/50 p-7 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="font-display text-xl font-bold text-mill-ink">Want to get more involved?</h2>
          <p className="mt-1 text-sm text-mill-muted">Volunteer, run a group or book a space — start your Mill journey from the home page.</p>
        </div>
        <Button className="gap-2 bg-mill-moss hover:bg-mill-moss-dark" onClick={() => nav("/")} data-testid="explore-get-involved">
          Choose your journey <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
      <div className="mt-8"><IllustrativeBadge /></div>
    </div>
  );
}
